import React from 'react'

export default function EmptyBillings(props) {
  return (
    <svg
      width={props.width ? props.width : '80'}
      height={props.height ? props.height : '88'}
      viewBox='0 0 80 88'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.5'
        d='M39.8461 50.3679H13.0981C12.4261 50.3679 11.8821 51.1829 11.8821 52.1879C11.8821 53.1949 12.4261 54.0079 13.0981 54.0079H39.8471C40.5191 54.0079 41.0631 53.1949 41.0631 52.1879C41.0631 51.1839 40.5191 50.3679 39.8461 50.3679Z'
        fill='#1D79FF'
      />
      <path
        opacity='0.5'
        d='M53.7331 39.4509H13.7021C12.6961 39.4509 11.8821 40.2639 11.8821 41.2699C11.8821 42.2759 12.6961 43.0899 13.7021 43.0899H53.7341C54.7411 43.0899 55.5541 42.2759 55.5541 41.2699C55.5541 40.2639 54.7391 39.4509 53.7331 39.4509Z'
        fill='#1D79FF'
      />
      <path
        opacity='0.5'
        d='M35.5941 61.2859H12.9131C12.3431 61.2859 11.8821 62.1009 11.8821 63.1059C11.8821 64.1129 12.3431 64.9259 12.9131 64.9259H35.5941C36.1641 64.9259 36.6251 64.1129 36.6251 63.1059C36.6251 62.1019 36.1641 61.2859 35.5941 61.2859Z'
        fill='#1D79FF'
      />
      <path
        opacity='0.5'
        d='M17.3411 28.533H13.7021C12.6961 28.533 11.8821 29.347 11.8821 30.353C11.8821 31.359 12.6961 32.172 13.7021 32.172H15.5221C15.5221 33.178 16.3351 33.992 17.3411 33.992C18.3471 33.992 19.1611 33.178 19.1611 32.172V31.838C21.2741 31.084 22.8001 29.083 22.8001 26.713C22.8001 23.703 20.3511 21.254 17.3411 21.254C16.3391 21.254 15.5211 20.438 15.5211 19.435C15.5211 18.431 16.3381 17.615 17.3411 17.615H20.9801C21.9861 17.615 22.8001 16.802 22.8001 15.796C22.8001 14.79 21.9861 13.976 20.9801 13.976H19.1601C19.1601 12.97 18.3461 12.157 17.3411 12.157C16.3351 12.157 15.5211 12.97 15.5211 13.976V14.311C13.4071 15.065 11.8821 17.066 11.8821 19.436C11.8821 22.446 14.3311 24.895 17.3411 24.895C18.3431 24.895 19.1611 25.71 19.1611 26.714C19.1611 27.718 18.3431 28.533 17.3411 28.533Z'
        fill='#1D79FF'
      />
      <path
        d='M57.7181 46.6931C67.7861 46.6931 75.9491 54.8391 75.9491 64.8861C75.9491 69.1811 74.4571 73.1291 71.9631 76.2411L79.4061 83.6711C80.1971 84.4611 80.1971 85.7411 79.4061 86.5301C78.6771 87.2591 77.5271 87.3151 76.7321 86.6981L76.5421 86.5301L69.0961 79.1011C65.9781 81.5901 62.0221 83.0791 57.7181 83.0791C47.6491 83.0791 39.4871 74.9341 39.4871 64.8861C39.4861 54.8391 47.6481 46.6931 57.7181 46.6931ZM57.7181 51.8751C49.8871 51.8751 44.6801 57.0721 44.6801 64.8871C44.6801 72.7021 49.8871 77.8991 57.7181 77.8991C65.5491 77.8991 70.7561 72.7031 70.7561 64.8871C70.7561 57.0721 65.5491 51.8751 57.7181 51.8751Z'
        fill='#1D79FB'
        fillOpacity='0.5'
      />
      <path
        d='M43.989 1.201C43.219 0.432 42.174 0 41.084 0H12.325C5.518 0 0 5.507 0 12.3V69.699C0 76.492 5.518 81.998 12.325 81.998H37.66C39.929 81.998 41.768 80.162 41.768 77.898C41.768 75.634 39.929 73.798 37.66 73.798H12.325C10.056 73.798 8.217 71.962 8.217 69.698V12.3C8.217 10.035 10.056 8.2 12.325 8.2H32.863L32.867 28.7L32.895 29.179C33.132 31.218 34.869 32.801 36.976 32.801H57.461V41.428C57.461 43.708 59.313 45.556 61.598 45.556C63.883 45.556 65.735 43.707 65.735 41.428V25.055C65.735 23.968 65.302 22.469 64.532 21.7L43.989 1.201ZM41.084 24.6L41.08 9.897L55.816 24.6H41.084Z'
        fill='#1D79FB'
        fillOpacity='0.5'
      />
      <path
        d='M54.475 59.6389L57.746 62.9009L61.017 59.6389C61.531 59.1249 62.3391 59.0859 62.9001 59.5199L63.0341 59.6389C63.5491 60.1519 63.5881 60.9589 63.1531 61.5179L63.0341 61.6519L59.7641 64.9169L63.0341 68.1809C63.5921 68.7369 63.5921 69.6379 63.0341 70.1949C62.4771 70.7499 61.574 70.7499 61.017 70.1949L57.746 66.9309L54.475 70.1949C53.961 70.7079 53.153 70.7479 52.592 70.3119L52.4581 70.1949C51.9431 69.6809 51.9041 68.8739 52.3391 68.3149L52.4581 68.1809L55.7281 64.9169L52.4581 61.6519C51.9001 61.0959 51.9001 60.1939 52.4581 59.6389C53.0151 59.0819 53.918 59.0819 54.475 59.6389Z'
        fill='#1D79FB'
        fillOpacity='0.5'
      />
    </svg>
  )
}
